import { fork } from "redux-saga/effects";
import { ShopSaga } from "../../components/Shop/ShopSaga";

export function* rootSaga() {
  yield fork(ShopSaga);
}
